<template>
  <basic-info-lottie-banner>
    <div class="aiBasicInfoSummary">
      <p class="aiBasicInfoSummary__lead">{{ leadText }}</p>
      <ul v-if="resourceNameFilled" class="aiBasicInfoSummary__list">
        <li
          v-for="item in checklist"
          :key="item.id"
          class="aiBasicInfoSummary__item"
          :class="{ 'aiBasicInfoSummary__item--done': item.done }"
        >
          <span class="aiBasicInfoSummary__mark">{{ item.done ? '✓' : '○' }}</span>
          <span class="aiBasicInfoSummary__label">{{ item.label }}</span>
          <span v-if="item.done && item.value" class="aiBasicInfoSummary__value">{{ item.value }}</span>
        </li>
      </ul>
    </div>
  </basic-info-lottie-banner>
</template>

<script>
import BasicInfoLottieBanner from './BasicInfoLottieBanner.vue'
import { normalizeAiRoleStringList } from '../../../aiAssistantManage/aiAssistantAdapter'

function filled(value) {
  return String(value == null ? '' : value).trim() !== ''
}

export default {
  name: 'AiAssistantBasicInfoSummary',
  components: { BasicInfoLottieBanner },
  props: {
    ruleForm: { type: Object, required: true },
  },
  computed: {
    resourceNameFilled() {
      return filled(this.ruleForm.resourceName || this.ruleForm.wallpaperName)
    },
    jsonConfig() {
      return this.ruleForm.jsonConfig || {}
    },
    aiRole() {
      return this.jsonConfig.aiRole || {}
    },
    leadText() {
      if (!this.resourceNameFilled) {
        return '请先填写运营名称，再在下方「Ai 角色配置」填写角色字段'
      }
      if (this.checklist.every((item) => item.done)) {
        return 'Ai 角色必填项已齐，可继续配置分类、Tag 与过滤条件'
      }
      return '运营名称已填好，请在下方「Ai 角色配置」继续填写'
    },
    checklist() {
      const prompt = Array.isArray(this.jsonConfig.prompt) ? this.jsonConfig.prompt[0] : null
      const welcomeList = normalizeAiRoleStringList(this.aiRole.welcome)
      const startersList = normalizeAiRoleStringList(this.aiRole.starters)
      return [
        {
          id: 'roleName',
          label: '角色名称',
          done: filled(this.aiRole.name),
          value: this.aiRole.name,
        },
        {
          id: 'llmModel',
          label: 'Model',
          done: filled(this.jsonConfig.llmModel),
          value: this.jsonConfig.llmModel,
        },
        {
          id: 'prompt',
          label: 'Prompt',
          done: filled(prompt && prompt.content),
          value: prompt && prompt.content ? '已填写' : '',
        },
        {
          id: 'avatar',
          label: 'Avatar',
          done: filled(this.aiRole.avatar),
          value: this.aiRole.avatar ? '已上传' : '',
        },
        {
          id: 'welcome',
          label: 'Welcome',
          done: welcomeList.length > 0,
          value: welcomeList.length ? `${welcomeList.length} 条` : '',
        },
        {
          id: 'starters',
          label: 'Starters',
          done: startersList.length > 0,
          value: startersList.length ? `${startersList.length} 条` : '',
        },
      ]
    },
  },
}
</script>

<style scoped>
.aiBasicInfoSummary__lead {
  margin: 0 0 10px;
  text-align: center;
  font-size: var(--link-text-sm, 13px);
  font-weight: var(--link-font-medium, 500);
  color: var(--link-ink-secondary, #4a4541);
  line-height: 1.55;
}

.aiBasicInfoSummary__list {
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: left;
}

.aiBasicInfoSummary__item {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 4px 0;
  font-size: var(--link-text-sm, 13px);
  color: var(--link-ink-muted, #7a746c);
}

.aiBasicInfoSummary__item--done {
  color: var(--link-ink-secondary, #4a4541);
}

.aiBasicInfoSummary__mark {
  flex-shrink: 0;
  width: 14px;
  text-align: center;
  font-weight: var(--link-font-medium, 500);
}

.aiBasicInfoSummary__label {
  flex-shrink: 0;
  min-width: 72px;
}

.aiBasicInfoSummary__value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--link-ink, #1f1c18);
}
</style>
